/**
 * Contains utility methods for SPRs used for sorting in ProductList.
 */
export default class ProductListSprUtility {
    static flattenSprsOrBundles(shoppingProducts, includedProducts) {
        if (!includedProducts) {
            return shoppingProducts;
        }
        const children = shoppingProducts
            .flatMap((sp) => Array(sp.quantity).fill(sp))
            .flatMap((sp) => sp.product.content?.child)
            .filter((child) => !!child);
        const childrenWithoutDuplicates = this.mergeDuplicateChildren(children);
        let childProducts = childrenWithoutDuplicates
            .map((child) => {
            const itemNo = child.itemId.split('-').reverse()[0];
            const product = (includedProducts.find((p) => itemNo === p.content?.itemNoLocal || itemNo === p.content?.itemNoGlobal));
            return { product, quantity: child.quantity };
        })
            .filter(({ product }) => product);
        if (childProducts.length > 0) {
            childProducts = this.flattenSprsOrBundles(childProducts, includedProducts);
        }
        return [
            ...shoppingProducts.filter((sp) => !sp.product.content?.child),
            ...childProducts
        ];
    }
    /**
     * Merges duplicated children and sums their quantities.
     *
     * @param children Children, with potentially duplicated products.
     */
    static mergeDuplicateChildren(children) {
        const childMap = children.reduce((all, curr) => {
            const child = all[curr.itemId];
            if (child) {
                const quantity = child.quantity + curr.quantity;
                return { ...all, [curr.itemId]: { ...child, quantity } };
            }
            return { ...all, [curr.itemId]: curr };
        }, {});
        return Object.values(childMap);
    }
}
//# sourceMappingURL=ProductListSprUtility.js.map